export const normalizeToArray = (value: unknown): string[] => {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value as string[];
  }
  if (typeof value === 'object') {
    return Object.values(value as Record<string, string>);
  }
  return [String(value)];
};
